/** Kế hoạch tạo/sửa/xoá việc từ MS.AICoaching (`pending_action`) — xác nhận qua MS.ActionPlan. */
export type ActionPlanAiPendingPlan = {
  action: "create" | "update" | "delete" | "manual" | "bsc_create" | "bsc_update" | "bsc_delete";
  mustManual?: boolean;
  reason?: string;
  idChoice?: string;
  year?: number;
  phanHe?: string;
  mucTieuId?: string;
  nguoiPhuTrachId?: string;
  /** User giao được cho người khác → không tự điền người phụ trách trên thẻ, phải chọn. */
  requireAssignee?: boolean;
  /** Tên + phòng ban người phụ trách trợ lý đã chốt (hiện cố định trên thẻ, không chọn tự do). */
  nguoiPhuTrachTen?: string | null;
  nguoiPhuTrachBoPhan?: string | null;
  /** Thẻ sửa: giá trị đang có (trợ lý gửi kèm) → hiện «cũ → mới». */
  before?: { tenCongViec?: string; moTa?: string | null; ngayBatDau?: string; ngayKetThuc?: string };
  tenCongViec?: string;
  moTa?: string;
  ngayBatDau?: string;
  ngayKetThuc?: string;
  parentId?: string | null;
  parentTen?: string | null;
  mucTieuTen?: string | null;
  /** Khóa select mục tiêu sau khi user chọn trên thẻ objective_list. */
  lockMucTieu?: boolean;
  taskId?: string;
  /** Hiển thị form chọn MT / NV / thời gian trong chat (mặc định create). */
  draftForm?: boolean;
  breakdownIndex?: number;
  breakdownTotal?: number;
  chiTieu?: number;
  idDoLuong?: string;
  /** Xoá: số việc con (mọi cấp) bị xoá kèm. */
  soViecCon?: number;
  /** Xoá: cây việc có tiến độ đã báo cáo. */
  coTienDo?: boolean;
  /** Plan bsc_* (dữ liệu B1–B5, engine `steps/tools`): bước con, nhóm, id mục, trường ghi, mô tả cho thẻ. */
  step?: string;
  stepTitle?: string;
  section?: string;
  sectionLabel?: string;
  id?: string;
  fields?: Record<string, unknown>;
  beforeText?: string;
  afterText?: string;
  label?: string;
  requestHeader?: Record<string, unknown>;
};

export const isBscStepPlan = (plan: Pick<ActionPlanAiPendingPlan, "action">) => plan.action.startsWith("bsc_");

export type ActionPlanAiPendingState = {
  plan: ActionPlanAiPendingPlan;
  status: "pending" | "confirming" | "done" | "error" | "dismissed";
  error?: string;
  resultId?: string;
  /** Lệnh do trợ lý đề xuất: điểm chờ duyệt của run — duyệt qua POST /runs/{runId}/resume (engine ghi). */
  runId?: string;
  interruptId?: string;
};
